module.exports = __webpack_public_path__ + "img/weixin_arrow.a10fc387.png";